import * as React from 'react'

export enum EnvironmentSwitchFilterType {
    is,
    isNot
}
export interface IEnvironmentSwitchProps extends React.ClassAttributes<EnvironmentSwitch> {
    filter: string,
    filterType: EnvironmentSwitchFilterType
} 

export class EnvironmentSwitch extends React.Component<IEnvironmentSwitchProps> {
    public render() {
        if(process.env.NODE_ENV === this.props.filter && this.props.filterType === EnvironmentSwitchFilterType.is
        || process.env.NODE_ENV !== this.props.filter && this.props.filterType === EnvironmentSwitchFilterType.isNot) {
            return this.props.children;
        } else {
            return (<div />); // TODO: 404
        }
    }
}



// WEBPACK FOOTER //
// ./src/Misc/EnvironmentSwitch.tsx